import { type Dispatch, type SetStateAction, useCallback, useState } from 'react';

type UseBooleanReturn = [
  value: boolean,
  setTrue: () => void,
  setFalse: () => void,
  toggle: () => void,
  setValue: Dispatch<SetStateAction<boolean>>,
];

export function useToggleBoolean(defaultValue = false): UseBooleanReturn {
  const [value, setValue] = useState(defaultValue);

  const setTrue = useCallback(() => {
    setValue(true);
  }, []);

  const setFalse = useCallback(() => {
    setValue(false);
  }, []);

  const toggle = useCallback(() => {
    setValue((x) => !x);
  }, []);

  return [value, setTrue, setFalse, toggle, setValue];
}
